import script from "./reportConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./reportConfig.vue?vue&type=script&setup=true&lang=js"

import "./reportConfig.vue?vue&type=style&index=0&id=75f6b1a4&lang=less"

const __exports__ = script;

export default __exports__